import React from 'react';

const SkeletonFanFavouriteCard = () =>
  <div className="fake-fan-favourite-card">
    <div className="fake-content-container">
      <div className="fake-left-container">
        <div className="fake-cover" />
      </div>
      <div className="fake-right-container" />
    </div>
  </div>;

export default SkeletonFanFavouriteCard;
